import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import MlmcreditInfo from './MlmcreditInfo';
import { convertToRS, convertToRSWithTwoDec } from 'core/js/FormUtils';
import MlmOrderDetails from './MlmOrderDetails';


export default function MlmcreditListTableRow({obj, getActionComponent,handleRowClick}){
  const {mobileView} = useSelector((state)=>state.menu);
  useEffect(()=>{
  },[])
  const getHoverColor = () =>{
    if (mobileView) return ''
    return 'primary.main';
  }
  const getHoverBackgroundColor = () =>{
    if (mobileView) return ''
    return 'secondary.200';
  }
  const getBackgroundColor = (obj) =>{
    //return 'white'
    //if (mobileView) {
      if (obj.expand) return 'secondary.100'
      return 'white'
    //}
    //return 'white'
  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" alignItems="left"
          onClick={() => handleRowClick(obj.id)}
            sx={{
              cursor: 'pointer',
              //borderBottom:'1px solid #C4C4C4',
              justifyContent: "flex-start", alignItems: "center",  
              backgroundColor: getBackgroundColor(obj),
              color: mobileView && obj.expand?'primary.main':'primary.darker',
              pb:1,pt:1,
              
            }}>
              <Grid item lg={2} xs={2} sx={{}}><Typography color="" sx={{ fontWeight: 'light', fontSize: 15, textAlign: 'left' }}>{obj.orderid}</Typography></Grid>
              
              <Grid item lg={4} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15, textAlign: 'left' }}>{obj.creditvianame}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15, textAlign: 'left' }}>{obj.creditlevel}</Typography></Grid>
              <Grid item lg={4} xs={5} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15, textAlign: 'left' }}>{convertToRSWithTwoDec(obj.creditvalue)} [{((obj.creditvalue/obj.ordervalue)*100).toFixed(2)}%]</Typography></Grid>
              
            
          </Grid>
        </Grid>
        <Grid item lg={12} sx={{ width: '100%'}}>
        {obj.expand ?
        <Grid container direction="row">
          <Grid item sx={{ width: '100%', backgroundColor:'secondary.100' }}>
            < MlmcreditInfo  mlmcreditObj={obj} />
          </Grid>
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>}
        </Grid>
      </>
      
    )
}